import { FeatureStateEnum } from '.spec/self-care/tsTypes';
import { ApolloClient, NormalizedCacheObject } from '@apollo/client';

import { FeaturesList } from '@skippay/core/@types/features';

import { useFeatureIsEnabled } from 'components/IfFeatureEnabled/useFeatureIsEnabled';
import FeatureFlagsQuery from 'queries/FeatureFlagsQuery.graphql';

import { isSupportedRuntime } from './utils';

type FeatureFlagsData = { featureFlags?: Partial<FeaturesList> };

export async function isJarabotFeatureEnabled(
	apolloClient: ApolloClient<NormalizedCacheObject>
): Promise<boolean> {
	if (!isSupportedRuntime()) return false;

	try {
		const response = await apolloClient.query<FeatureFlagsData>({
			fetchPolicy: 'cache-first',
			query: FeatureFlagsQuery,
		});

		return response.data?.featureFlags?.jarabot === FeatureStateEnum.ENABLED;
	} catch {
		return false;
	}
}

export function useJarabotFeatureIsEnabled(): boolean {
	const { isFeatureEnabled } = useFeatureIsEnabled('jarabot');

	return isFeatureEnabled && isSupportedRuntime();
}
